import React, { Component } from 'react'
import intl from 'react-intl-universal'
import AuthorisationHandler from '../components/AuthorisationHandler'
import ResultsInnerExperience from '../components/ResultsInnerExperience'
import Loading from '../components/Loading'
import Page from './Page'
import ProfileMenu from '../components/ProfileMenu'
import shortid from 'shortid'
import { inject, observer, PropTypes } from 'mobx-react/index'

@inject('my_bookings', 'user')
@observer
class ProfileMyBookingsPage extends Component {
  constructor (props) {
    super(props)

    const {user, my_bookings} = props
    const {token} = user
    my_bookings.get(token)
  }

  render () {
    const {user, my_bookings} = this.props
    const {grouped_bookings} = my_bookings
    console.log('ProfileMyBookingsPage - render() - grouped_bookings:', grouped_bookings)

    return (
      <AuthorisationHandler>
        <Page title='My bookings'>
          <section className='b-profile'>
            <div className='b-profile-inner'>

              <ProfileMenu />

              <div className='b-profile-main'>
                <h3 className='b-profile-title'>{intl.get('profile.my_bookings')}</h3>

                {!my_bookings.loaded
                  ? <div><Loading /></div>
                  : <div className='b-profile-experiences'>
                    {grouped_bookings
                      ? Object.entries(grouped_bookings).map(([group_name, group]) => {
                        if (group.length > 0) {
                          return (
                            <div key={shortid.generate()}
                                 className='b-profile-experiences-group'>
                              <div className='b-profile-experiences-group-items'>
                                {group.map((booking, index) =>
                                  <ResultsInnerExperience
                                    key={shortid.generate()}
                                    experience={booking.experience}
                                    date={booking.formatted_date}
                                    is_before={booking.is_before}
                                    is_today={booking.is_today}
                                    is_after={booking.is_after}
                                    // hide_expired_date={true}
                                    variant={booking.variant}
                                    topic={booking.topic || ' '}
                                    show_liked={true}
                                    show_price={false}
                                    show_table={true}
                                    show_rating={false}
                                    show_guests={false}
                                    show_user={true}
                                  />)}
                              </div>
                            </div>
                          )
                        }
                      })
                      : <div className='b-empty'><div className='b-empty-text'>Keine Buchungen</div></div>}
                  </div>}
              </div>
            </div>
          </section>
        </Page>
      </AuthorisationHandler>
    )
  }
}

ProfileMyBookingsPage.propTypes = {
  my_bookings: PropTypes.observableObject,
  user: PropTypes.observableObject
}

export default ProfileMyBookingsPage



// WEBPACK FOOTER //
// ./src/containers/ProfileMyBookingsPage.js